import type {HTMLAttributes, ReactNode} from 'react';

import classNames from 'classnames';

import styles from './core-entity-main-column.module.css';

type Props = {
    children: ReactNode;
    /** Scroll container for core entity pages when using full-height sidebar layout. */
    scrollContainerRef?: (el: HTMLDivElement | null) => void;
    id?: string;
} & Omit<HTMLAttributes<HTMLDivElement>, 'children'>;

export function CoreEntityMainColumn(props: Props) {
    const {children, scrollContainerRef, id, className, ...rest} = props;

    return (
        <div
            {...rest}
            id={id}
            ref={scrollContainerRef}
            className={classNames(styles['main-column'], className)}
        >
            {children}
        </div>
    );
}
